'use client'
import FadeUpOnVisible from '@/animations/FadeUpOnVisible'
import Button from '@/components/Button'
import Dropdown from '@/components/form/Dropdown'
import Input from '@/components/form/Input'
import Textarea from '@/components/form/Textarea'
import {FormEvent, useState} from 'react'

type FormDataType = {
  name: {value: string}
  email: {value: string}
  company: {value: string}
  subject: {defaultValue: string}
  message: {value: string}
}
const Form = () => {
  const [result, setResult] = useState<string>()
  const [errors, setErrors] = useState<string[]>([])

  const formValidation = (formData: FormDataType) => {
    const errors = []
    if (!formData.name.value) errors.push('name')
    if (!formData.email.value) errors.push('email')
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email.value)) errors.push('email-format')
    if (!formData.subject.defaultValue) errors.push('subject')
    if (!formData.message.value) errors.push('message')

    return errors
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const formData = e.currentTarget as unknown as FormDataType

    const errors = formValidation(formData)
    if (errors.length > 0) {
      setErrors(errors)
      return
    }

    const data = {
      'form-name': 'contact',
      name: formData.name.value,
      email: formData.email.value,
      subject: formData.subject.defaultValue,
      company: formData.company.value,
      message: formData.message.value
    }

    fetch('/form.html', {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: new URLSearchParams(data).toString()
    })
      .then(e => {
        setResult(
          e.status !== 200
            ? 'There was an error sending out your form!\nPlease reach out through email!'
            : "Thank you!\nYour message have been submitted and we'll be in touch shortly."
        )
      })
      .catch(error => setResult(error))
  }

  return (
    <FadeUpOnVisible className="col-span-4 py-8 md:col-span-6 md:col-start-2 lg:col-span-10 lg:col-start-2 lg:py-16" threshold={0}>
      {!result ? (
        <form
          id="contactForm"
          name="contact"
          method="POST"
          onSubmit={handleSubmit}
          data-netlify="true"
          netlify-honeypot="anti-bot"
          className="flex flex-col items-center"
        >
          <input type="hidden" name="form-name" value="contact" />
          <input hidden name="anti-bot" />
          <Input name="name" label="Name" error={errors.includes('name')} />
          <Input name="email" label="Email" error={errors.includes('email') || errors.includes('email-format')} />
          <Input name="company" label="Company" />
          <Dropdown
            name="subject"
            label="Subject"
            options={['New project', 'Offer', 'Sales', 'Support', 'Others']}
            error={errors.includes('subject')}
          />
          <Textarea name="message" label="Message" error={errors.includes('message')} />
          {errors.length > 0 && (
            <p className="w-full bg-[rgba(255,51,59,0.1)] pt-1 text-center text-body-md">
              {errors[0] === 'email-format' ? 'Please enter a valid email' : 'Please fill the required fields'}
            </p>
          )}
          <div className="pt-8">
            <Button label="Send" type="submit" fluid={false} />
          </div>
        </form>
      ) : (
        <p className="whitespace-pre-line text-center text-headline-sm lg:text-headline-md">{result}</p>
      )}
    </FadeUpOnVisible>
  )
}

export default Form
